// src/Services/AdminServices/ReportService.js
import axiosInstance from "api/axiosInstance";
import API from "api/endpoints";

const ReportService = {
  //  Hiring report
  getHiringReport: async (departmentId) => {
    return axiosInstance.get(API.reports.getHiringReport(departmentId));
  },

  //  Job applicant report
  getJobApplicantReport: async (filters = {}) => {
    // You can pass departmentId, month, year as filters
    const params = new URLSearchParams(filters).toString();
    const url = params
      ? `${API.reports.getJobApplicantReport}?${params}`
      : API.reports.getJobApplicantReport;

    return axiosInstance.get(url);
  },

  //  Department list
  getDepartments: async () => {
    return axiosInstance.get(API.department.getList);
  },
  getExpenseReport: async (departmentId = 1, month = null, year = null) => {
    // Call the function to get the actual URL string
    const endpointUrl = API.reports.getExpenseReport(departmentId, month, year);
    return axiosInstance.get(endpointUrl);
  },

  getAttendanceReport: async (departmentId = 1, month = null, year = null) => {
    const endpointUrl = API.reports.getAttendanceReport(departmentId, month, year);
    return axiosInstance.get(endpointUrl);
  },

  getLeaveReport: async (departmentId = 1, month = null, year = null) => {
    try {
      const endpointUrl = API.reports.leaveRequestReport(departmentId, month, year);
      return await axiosInstance.get(endpointUrl);
    } catch (error) {
      console.error("Error in getLeaveReport:", error);
      throw error;
    }
  },

  downloadReport: async (departmentId = null) => {
    let url = API.adminReports.downloadReport;
    if (departmentId) url += `?departmentId=${departmentId}`;
    return axiosInstance.get(url, { responseType: "blob" });
  },
};

export default ReportService;
